import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import MultiSelect from '@khanacademy/react-multi-select'
import i18n from 'Pods/Shared/I18n'
import ComponentSearch from '../../../Shared/ComponentSearch'
import Icon from '../../../Shared/Icon/Icon'

class ProjectsListFilters extends React.Component {
  constructor() {
    super()

    this.state = {
      isExpanded: false,
    }

    this.handleExpand = this.handleExpand.bind(this)
    this.handleFilterChange = this.handleFilterChange.bind(this)
    this.trackFilterChange = this.trackFilterChange.bind(this)
  }

  handleExpand() {
    this.setState({ isExpanded: !this.state.isExpanded })
  }

  trackFilterChange({ name, value }) {
    const { filters, locale } = this.props
    const keywords = filters.term || ''
    const modelingJob = i18n.t('projects.modelingJob', { ns: 'rails', lng: locale } )

    window.filterTracker({
      name,
      value,
      searchTerm: keywords || '',
      type: modelingJob,
    })

    window.searchTracker({
      searchTerm: keywords || '',
      type: modelingJob,
    })
  }

  handleFilterChange(filter, value) {
    const { onFiltersChange, filters } = this.props
    const currentFilters = filters[filter] || []
    const isFilterSelected = value.length > currentFilters.length
    const isFilterDeselected = value.length < currentFilters.length

    if (isFilterSelected) {
      const newFilter = value
        .filter((element) => currentFilters.every((currentValue) => currentValue !== element))

      if (newFilter.length) {
        const currentValue = newFilter.pop()
        const matchingLabels = filter === 'skills' ? this.props.skillsFilterOptions : this.props.softwareFilterOptions
        const selectedLabel = matchingLabels.find(option => option.value === currentValue)
        const matchingLabel = selectedLabel ? selectedLabel.label : ''

        this.trackFilterChange({ name: filter, value: matchingLabel })
      }
    }

    if (isFilterDeselected) {
      const removedFilter = currentFilters
        .filter((element) => value.every((currentValue) => currentValue !== element))

      if (removedFilter.length) {
        const currentValue = removedFilter.pop()
        const matchingLabels = filter === 'skills' ? this.props.skillsFilterOptions : this.props.softwareFilterOptions
        const selectedLabel = matchingLabels.find(option => option.value === currentValue)
        const matchingLabel = selectedLabel ? selectedLabel.label : ''

        window.removeCurrentSearchFilter({
          name: filter,
          value: matchingLabel,
        })
      }
    }

    onFiltersChange({
      ...filters,
      [filter]: value,
    })
  }

  render() {
    const searchPlaceholder = i18n.t('projects.searchPlaceholder', { ns: 'rails', lng: this.props.locale } )
    const className = this.state.isExpanded ? ' form-inline--is-expanded' : ''
    const placeholderSoftware = i18n.t('projects.software', { ns: 'rails', lng: this.props.locale } )
    const placeholderSkills = i18n.t('projects.skills', { ns: 'rails', lng: this.props.locale } )
    const localizedSkillsFilterOptions = this.props.skillsFilterOptions.map(option => {
      const translationKey = i18n.t(`skills.${option.slug}`, { ns: 'rails', lng: this.props.locale } )
      return { ...option, label: translationKey }
    })

    return (
      <div className="projects-list__filters">
        <div className={`form-inline row justify-content-between${className}`}>
          <div className="form-inline__column-toggler col-sm-12">
            <div className="form-inline__mobile-toggle" onClick={() => this.handleExpand()}>
              <span>Search & filter</span>
              <Icon type={['far', 'chevron-down']} className="form-inline__mobile-toggle-icon" />
            </div>
          </div>
          <div className="col-sm-12 col-md-4">
            <ComponentSearch
              onSearchSubmit={this.props.onSearchSubmit}
              searchTerm={this.props.filters.term}
              onTermChange={this.props.onTermChange}
              isDisabled={this.props.isDisabled}
              locale={this.props.locale}
            />
          </div>
          <div className="col-sm-12 col-md-8">
            <div className="row justify-content-end">
              <div className="col-12 col-md-4 col-xl-3">
                <MultiSelect
                  options={this.props.softwareFilterOptions}
                  onSelectedChanged={(value) => { this.handleFilterChange('software', value) }}
                  selected={this.props.filters.software}
                  placeholder={placeholderSoftware}
                  disabled={this.props.isDisabled}
                  hasSelectAll={false}
                  disableSearch
                />
              </div>
              <div className="col-12 col-md-3 col-xl-3">
                <MultiSelect
                  options={localizedSkillsFilterOptions}
                  onSelectedChanged={(value) => { this.handleFilterChange('skills', value) }}
                  selected={this.props.filters.skills}
                  placeholder={placeholderSkills}
                  disabled={this.props.isDisabled}
                  hasSelectAll={false}
                  disableSearch
                />
              </div>
              <div className="col-12 col-md-3">
                <Select
                  name="projects-list-sort"
                  value={this.props.filters.sortBy}
                  options={this.props.sortOptions}
                  onChange={this.props.onSortChange}
                  placeholder="Sort"
                  className="Select-outline"
                  searchable={false}
                  clearable={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

ProjectsListFilters.propTypes = {
  onSearchSubmit: PropTypes.func.isRequired,
  onTermChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  softwareFilterOptions: PropTypes.array.isRequired,
  skillsFilterOptions: PropTypes.array.isRequired,
  sortOptions: PropTypes.array.isRequired,
  onFiltersChange: PropTypes.func.isRequired,
  onSortChange: PropTypes.func.isRequired,
  filters: PropTypes.shape({
    term: PropTypes.string.isRequired,
    sortBy: PropTypes.string.isRequired,
    software: PropTypes.array.isRequired,
    skills: PropTypes.array.isRequired,
  }).isRequired,
}

ProjectsListFilters.defaultProps = {
  isDisabled: false,
}

export default ProjectsListFilters
